/**
 * Datos minimos para etiquetar un producto. Es estructural a proposito: sirve igual
 * para el maestro de productos, para la linea de un documento y para el snapshot que
 * devuelve el offcanvas de busqueda.
 */
export type ProductLabelFields = {
    codigo?: string | null;
    descripcion_fact?: string | null;
};

/**
 * Etiqueta con la que se muestra un producto donde solo se guarda su id: `{codigo}` a
 * secas, o `{codigo} - {descripcion}` cuando la tiene.
 */
export const buildProductOptionLabel = (product?: ProductLabelFields | null): string => {
    const codigo = `${product?.codigo || ""}`.trim();
    const descripcion = `${product?.descripcion_fact || ""}`.trim();

    if (!descripcion) {
        return codigo;
    }
    return codigo ? `${codigo} - ${descripcion}` : descripcion;
};
